import { render, staticRenderFns } from "./GroupMembersModalMenu.vue?vue&type=template&id=0c29a59f&scoped=true"
import script from "./GroupMembersModalMenu.vue?vue&type=script&lang=js"
export * from "./GroupMembersModalMenu.vue?vue&type=script&lang=js"
import style0 from "./GroupMembersModalMenu.vue?vue&type=style&index=0&id=0c29a59f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c29a59f",
  null
  
)

export default component.exports